// extracted by mini-css-extract-plugin
export var colorSquare = "_sf-0";
export var danger = "_sf-5";
export var lightPink = "_sf-8";
export var neutralBlue = "_sf-7";
export var neutralYellow = "_sf-6";
export var normal = "_sf-1";
export var primary = "_sf-2";
export var primaryLight = "_sf-3";
export var solidBlack = "_sf-g";
export var solidGreen = "_sf-b";
export var solidLightBlue = "_sf-d";
export var solidNavy = "_sf-c";
export var solidOrange = "_sf-f";
export var solidPink = "_sf-e";
export var solidRed = "_sf-9";
export var solidYellow = "_sf-a";
export var success = "_sf-4";